import styled from 'styled-components';
export var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "s9jboq-0"
})(["height:20px;line-height:20px;margin-top:0 !important;"]);